export const Types = {
    SET_BACKDROP: "SET_BACKDROP",
    RESET_BACKDROP: "RESET_BACKDROP",
};

export const setBackdrop = () => ({
    type: Types.SET_BACKDROP,
});

export const resetBackdrop = () => ({
    type: Types.RESET_BACKDROP,
});
